import { render, staticRenderFns } from "./tariff.vue?vue&type=template&id=6739b77f&scoped=true&"
import script from "./tariff.vue?vue&type=script&lang=js&"
export * from "./tariff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6739b77f",
  null
  
)

export default component.exports